import React from 'react';
import { makeStyles, Typography } from '@material-ui/core';
import arjanRing from '../assets/pic/arjan_ring.jpg';
import arjanCup from '../assets/pic/arjan_cup.jpg';

/* هیروی مشترکِ صفحاتِ احراز هویت (ورود، ادعای حساب، تعیین رمز) */

const useStyles = makeStyles((theme) => ({
  hero: {
    position: 'relative',
    width: '100%',
    minHeight: '100vh',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(150deg, #101a4d 0%, #1a237e 42%, #4b3fa7 76%, #764ba2 100%)',
    [theme.breakpoints.down('md')]: {
      display: 'block',
      minHeight: 'auto',
      paddingBottom: 44,
    },
  },
  brandPanel: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    width: '40%',
    padding: '48px 44px',
    paddingRight: 130,
    color: '#fff',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    zIndex: 2,
    [theme.breakpoints.down('lg')]: { width: '42%', paddingRight: 150 },
    [theme.breakpoints.down('md')]: {
      position: 'static',
      width: '100%',
      padding: '34px 20px 70px',
      alignItems: 'center',
      textAlign: 'center',
    },
  },
  cupBg: {
    position: 'absolute',
    width: '68%',
    right: '-14%',
    bottom: '-20%',
    opacity: 0.17,
    mixBlendMode: 'screen',
    transform: 'rotate(-8deg)',
    pointerEvents: 'none',
    zIndex: 1,
    [theme.breakpoints.down('md')]: {
      width: 340,
      right: -110,
      bottom: 'auto',
      top: -90,
    },
  },
  ringLogo: {
    width: 92,
    height: 92,
    borderRadius: '50%',
    objectFit: 'cover',
    border: '2px solid rgba(255,215,120,.65)',
    boxShadow: '0 0 34px rgba(255,200,80,.45), 0 8px 24px rgba(0,0,0,.35)',
    marginBottom: 22,
    position: 'relative',
    zIndex: 2,
    [theme.breakpoints.down('sm')]: { width: 72, height: 72, marginBottom: 14 },
  },
  brandTitle: {
    fontSize: 28,
    fontWeight: 800,
    lineHeight: 1.6,
    position: 'relative',
    zIndex: 2,
    [theme.breakpoints.down('sm')]: { fontSize: 22 },
  },
  brandText: {
    fontSize: 14,
    opacity: 0.85,
    marginTop: 10,
    lineHeight: 2,
    position: 'relative',
    zIndex: 2,
    [theme.breakpoints.down('sm')]: { fontSize: 12.5 },
  },
  brandList: {
    listStyle: 'none',
    marginTop: 26,
    padding: 0,
    position: 'relative',
    zIndex: 2,
    [theme.breakpoints.down('sm')]: { display: 'none' },
  },
  bullet: {
    fontSize: 13,
    display: 'flex',
    alignItems: 'center',
    gap: 9,
    marginBottom: 13,
    opacity: 0.92,
  },
  check: {
    width: 20,
    height: 20,
    borderRadius: '50%',
    background: 'rgba(255,255,255,.18)',
    border: '1px solid rgba(255,255,255,.3)',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 11,
    flexShrink: 0,
    marginLeft: 8,
  },
  cardWrap: {
    position: 'relative',
    zIndex: 3,
    margin: '0 auto',
    [theme.breakpoints.up('md')]: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 390,
    },
    [theme.breakpoints.down('md')]: {
      position: 'relative',
      top: 'auto',
      left: 'auto',
      transform: 'none',
      width: '100%',
      padding: '0 14px',
    },
  },
  loginCard: {
    width: '100%',
    background: '#fff',
    borderRadius: 18,
    boxShadow: '0 18px 50px rgba(8, 12, 40, .35)',
    border: '1px solid rgba(255,255,255,.35)',
    padding: '24px 22px',
    position: 'relative',
    zIndex: 2,
    [theme.breakpoints.down('sm')]: { borderRadius: 16, padding: '20px 16px' },
  },
  cardTitle: {
    fontSize: 18,
    fontWeight: 800,
    textAlign: 'center',
    marginBottom: 4,
  },
  cardSub: {
    fontSize: 12.5,
    color: '#7a80a3',
    textAlign: 'center',
    marginBottom: 14,
    lineHeight: 1.9,
  },
}));

export default function AuthHero({ title, subtitle, children }) {
  const classes = useStyles();
  return (
    <div className={classes.hero}>
      <img className={classes.cupBg} src={arjanCup} alt="" />
      <div className={classes.brandPanel}>
        <img className={classes.ringLogo} src={arjanRing} alt="حلقه طلایی ارجان" />
        <Typography className={classes.brandTitle} component="h1">
          سامانه ارجان پیمان
        </Typography>
        <Typography className={classes.brandText}>
          دسترسی سریع و امن پیمانکاران به آخرین وضعیت قراردادها، صورت وضعیت‌ها و حواله‌ها
        </Typography>
        <ul className={classes.brandList}>
          <li className={classes.bullet}><span className={classes.check}>✓</span> مشاهدهٔ لحظه‌ای قراردادها و صورت وضعیت‌ها</li>
          <li className={classes.bullet}><span className={classes.check}>✓</span> دریافت گزارش PDF و اکسل</li>
          <li className={classes.bullet}><span className={classes.check}>✓</span> ورود امن با رمز یکبار مصرف</li>
        </ul>
      </div>
      <div className={classes.cardWrap}>
        <div className={classes.loginCard}>
          <Typography className={classes.cardTitle} component="h2">{title}</Typography>
          {subtitle ? <Typography className={classes.cardSub}>{subtitle}</Typography> : null}
          {children}
        </div>
      </div>
    </div>
  );
}
